import { render, staticRenderFns } from "./LocationPrompt.vue?vue&type=template&id=8279c196&scoped=true&"
var script = {}
import style0 from "./LocationPrompt.vue?vue&type=style&index=0&id=8279c196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8279c196",
  null
  
)

export default component.exports